import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'act-text-area',
  templateUrl: './act-text-area.component.html',
  styleUrls: ['./act-text-area.component.scss']
})
export class ActTextAreaComponent implements OnChanges {

  @Input() id: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() maxLength: number;
  @Input() isError: boolean;
  @Input() errorText: string;

  @Output() text = new EventEmitter<string>();

  ngOnChanges() {
  }

  onKeyup(event) {
    if (event.key != ' ' || event.target.value.trim().length != 0) {
      this.text.emit(event.target.value.trim())
    }
  }

  onKeySpace(event) {
    if (event.target.value.trim().length == 0) {
      event.preventDefault()
    }
  }

  onFocusOut(event) {
    event.target.value = event.target.value.trim()
  }

}



// WEBPACK FOOTER //
// ./src/app/components/act-text-area/act-text-area.component.ts